import { User, useWhoamiQuery } from 'graphql-common';
import _get from 'lodash/get';
import { WatchQueryFetchPolicy } from '@apollo/client';

type Args = {
  fetchPolicy?: WatchQueryFetchPolicy;
};

export default function useWhoamiQueryHook(args?: Args) {
  const { fetchPolicy } = args || {};
  const { data, error, refetch, loading, networkStatus } = useWhoamiQuery({
    fetchPolicy: fetchPolicy || 'cache-and-network',
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });
  const currentUser = _get(data, 'whoami.resource') as User;
  const currentUserDeactivatedAt = currentUser?.deactivatedAt;
  const currentUserEmail = currentUser?.email;
  const currentUserId = currentUser?.id;
  const currentUserLang = currentUser?.lang;
  const currentUserUnconfirmedEmail = currentUser?.unconfirmedEmail;
  const currentUserUsername = currentUser?.username;
  const firstLoading = loading && data === undefined;
  return {
    currentUser,
    currentUserDeactivatedAt,
    currentUserEmail,
    currentUserId,
    currentUserLang,
    currentUserUnconfirmedEmail,
    currentUserUsername,
    data,
    error,
    firstLoading,
    loading,
    networkStatus,
    refetch,
  };
}
